// import { odsTokens } from 'kfone-component-library';
import { odsTokens } from 'kfone-component-library/odsTokens';

export const ChartFonts = {
  OPEN_SANS: odsTokens.fontFamily['ods-font-family-secondary'],
};
